import { useState,useContext, useEffect } from "react";
import './sound.scss';
import {ReactComponent as SoundOff} from "../../Assets/Svg/sound-off.svg";
import {ReactComponent as SoundOn} from "../../Assets/Svg/sound-on.svg";
import VolumeContext from "../../Contexts/Volume";
import { playMenuOver,playSwitchOff } from "../../Sounds/Sounds";
const Sound = () => {
    const [currentSound, setCurrentSound] = useState<string>(localStorage.getItem("sound") || "true");
    const {setVolume} = useContext(VolumeContext);


    const changeSound = () => {
        playSwitchOff();
        setCurrentSound(currentSound === "true" ? "false" : "true")
        localStorage.setItem("sound",currentSound === "true" ? "false" : "true");
        setVolume(currentSound === "true" ? 0 : 1);
    }

    useEffect(() =>{
        setVolume(currentSound === "true" ? 1 : 0)
    },[])

    return(
        <div className="sound" onClick={changeSound} onMouseEnter={() => {playMenuOver()}}>
            <SoundOn style={{opacity: currentSound === "true" ? 1 : 0}}/>
            <SoundOff style={{opacity: currentSound === "false" ? 1 : 0}}/>
        </div>
    )
}
export default Sound